export default class Hero {

  constructor() {
    const heroForm = document.getElementById('plan-trip');

    if (heroForm) {
      this.initPlanTripMap(heroForm);
    }
  }

  initPlanTripMap(heroForm) {
    const dropdownButton = heroForm.querySelector('[data-trip-dropdown]');
    const dropdownItems = heroForm.querySelectorAll('[data-trip-option]');
    const dropdownValue = heroForm.querySelector('[name="departure_type"]');

    if (!dropdownButton || !dropdownItems.length) {
      return;
    }

    dropdownItems.forEach((item) => {
      item.addEventListener('click', () => {
        const label = item.textContent.trim();
        const value = item.dataset.tripOption;

        dropdownButton.querySelector('span').textContent = label;

        if (dropdownValue) {
          dropdownValue.value = value;
        }

        dropdownItems.forEach((option) => {
          option.classList.remove('active');
        });

        item.classList.add('active');
      });
    });
  }
}